import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './StepsProvider.css';
import React from 'react';
import { PassportDetails, ApplicantDetails, PaymentSubmit } from './StepsTemplates';
import { getDictionaryItem } from '../../../utils';
import UploadDocuments from './StepsTemplates/UploadDocuments';
import { Translate } from './actions';
var StepsProvider = function StepsProvider(props) {
  var currentStepId = props.currentStepId,
    context = props.context,
    updateContext = props.updateContext,
    steps = props.steps,
    apiConfig = props.apiConfig,
    getLookupOptions = props.getLookupOptions;
  var setTranslateValue = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(relatedName, value) {
      var field, newVal;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            field = context[relatedName]; // api call
            _context.next = 3;
            return Translate(apiConfig, value);
          case 3:
            newVal = _context.sent;
            updateContext(_defineProperty2({}, relatedName, _objectSpread(_objectSpread({}, field), {}, {
              value: newVal,
              valid: true
            })));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function setTranslateValue(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var GenerateStepData = function GenerateStepData(fieldsList, dictionary) {
    fieldsList.forEach(function (_ref2) {
      var selectOptionName = _ref2.selectOptionName,
        apiName = _ref2.apiName,
        name = _ref2.name,
        type = _ref2.type,
        required = _ref2.required,
        relatedFieldName = _ref2.relatedFieldName,
        _ref2$options = _ref2.options,
        options = _ref2$options === void 0 ? [] : _ref2$options,
        replacedFieldName = _ref2.replacedFieldName,
        _ref2$staticName = _ref2.staticName,
        staticName = _ref2$staticName === void 0 ? '' : _ref2$staticName;
      var fieldName = apiName || replacedFieldName || name;
      var currentField = context[fieldName];
      if (currentField && currentField.name) return;
      switch (type) {
        case 'select':
          {
            updateContext(_defineProperty2({}, fieldName, {
              value: currentField && currentField.value.toString() || '',
              name: fieldName,
              label: getDictionaryItem(dictionary, name) || staticName,
              required: required,
              selectOptionName: selectOptionName,
              options: selectOptionName && getLookupOptions && getLookupOptions(selectOptionName) || currentField && currentField.options || options || [],
              valid: currentField && currentField.valid || !required
            }));
            break;
          }
        case 'text':
          {
            console.log(fieldName, currentField && currentField.valid || !required);
            updateContext(_defineProperty2({}, fieldName, {
              value: currentField && currentField.value || '',
              name: fieldName,
              type: type,
              label: getDictionaryItem(dictionary, name) || staticName,
              required: required,
              relatedFieldName: relatedFieldName,
              valid: currentField && currentField.valid || !required
            }));
            break;
          }
        case 'email':
          {
            updateContext(_defineProperty2({}, fieldName, {
              value: currentField && currentField.value || '',
              name: fieldName,
              type: type,
              label: getDictionaryItem(dictionary, name),
              required: required,
              relatedFieldName: relatedFieldName,
              valid: currentField && currentField.valid || !required
            }));
            break;
          }
        case 'date':
          {
            updateContext(_defineProperty2({}, fieldName, {
              value: currentField && currentField.value || '',
              name: fieldName,
              label: getDictionaryItem(dictionary, name) || staticName,
              required: required,
              valid: currentField && currentField.valid || !required
            }));
            break;
          }
        case 'phone':
          {
            updateContext(_defineProperty2({}, fieldName, {
              value: currentField && currentField.value || '',
              name: fieldName,
              label: getDictionaryItem(dictionary, name),
              required: required
            }));
            break;
          }
        case 'checkbox':
          {
            updateContext(_defineProperty2({}, fieldName, {
              value: currentField && currentField.value || false,
              name: fieldName,
              label: getDictionaryItem(dictionary, name) || staticName,
              required: required,
              valid: currentField && currentField.valid || !required
            }));
            break;
          }
        case 'radio':
          {
            updateContext(_defineProperty2({}, fieldName, {
              value: currentField && currentField.value || '',
              name: fieldName,
              label: getDictionaryItem(dictionary, name),
              required: required,
              options: options,
              valid: currentField && currentField.valid || !required
            }));
            break;
          }
      }
    });
  };
  var getTranslateValue = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(name, relatedName) {
      var field, relatedField, value, newVal;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            field = context[name];
            relatedField = context[relatedName];
            value = relatedField.value;
            if (value.length) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return");
          case 5:
            _context2.next = 7;
            return Translate(apiConfig, value);
          case 7:
            newVal = _context2.sent;
            updateContext(_defineProperty2({}, name, _objectSpread(_objectSpread({}, field), {}, {
              value: newVal,
              valid: true
            })));
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getTranslateValue(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var validateCurrentFields = function validateCurrentFields(fieldsList) {
    var invalidFields = fieldsList.find(function (_ref4) {
      var apiName = _ref4.apiName,
        name = _ref4.name,
        required = _ref4.required;
      var currentName = apiName && apiName.length && apiName || name;
      if (!required) return false;
      if (!context[currentName]) return true;
      return !context[currentName].valid;
    });
    console.log(invalidFields);
    return !!invalidFields;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ")
  }, function () {
    switch (currentStepId) {
      case 0:
        return /*#__PURE__*/React.createElement(PassportDetails, _extends({}, props, {
          stepConfig: steps[0],
          validateCurrentFields: validateCurrentFields,
          setTranslateValue: setTranslateValue,
          getTranslateValue: getTranslateValue,
          generateStepData: GenerateStepData
        }));
      case 1:
        return /*#__PURE__*/React.createElement(ApplicantDetails, _extends({}, props, {
          stepConfig: steps[1],
          validateCurrentFields: validateCurrentFields,
          setTranslateValue: setTranslateValue,
          getTranslateValue: getTranslateValue,
          generateStepData: GenerateStepData
        }));
      case 2:
        return /*#__PURE__*/React.createElement(UploadDocuments, _extends({}, props, {
          stepConfig: steps[2],
          documents: props.documents
        }));
      case 3:
        return /*#__PURE__*/React.createElement(PaymentSubmit, _extends({}, props, {
          stepConfig: steps[3]
        }));
    }
  }());
};
export default StepsProvider;
var commonStyles = "c1bdjmm9";